<div class="dx-card wide-card">
    <div class="row">
        <div class="col-11">
    <h4 class="content-block ap-green">Activity Process Feedstock</h4>
</div>
<div class="col-1 text-left">
    <dx-button [(visible)]="closeButtonVisible" (onClick)="onClose()" class="ap-discard-button  px-2 mt-2">Close</dx-button>
</div>
</div>
    <dx-data-grid *ngIf="activityProcessFeedstocks && productionactivities && specificprocesses && feedstocks"
        class="fixGridHeight" id="ActivityProcessFeedstockGrid" [dataSource]="activityProcessFeedstocks"
        (onEditorPreparing)="onEditorPreparing($event)" (onRowInserted)="addActivityProcessFeedstock($event)"
        (onInitNewRow)="onInitNewRow($event)" (onEditingStart)="onEditingStart($event)" (onRowUpdated)="updateActivityProcessFeedstock($event)"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true"
        [rowAlternationEnabled]="true" keyExpr="productionActivityId" keyExpr="activityProcessFeedstockId">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-editing mode="popup" [useIcons]="true" [allowUpdating]="true" [allowAdding]="true">
            <dxo-popup title="Add/Edit Activity Process Feedstock" [showTitle]="true" [toolbarItems]="[  
            {  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Save',  
              icon: '',
              stylingMode:'contained',
              type:'success'
            },  
            toolbar: 'bottom',  
            onClick: onSaveClick  
        },{  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Cancel',  
              type: 'danger',
              icon: ''  
            },  
            toolbar: 'bottom',  
            onClick: onCancelClick  
        }]">
            </dxo-popup>
            <dxo-form>

                <dxi-item dataField="productionActivityId">
                    <dxi-validation-rule type="required" message="Production Activity is required"></dxi-validation-rule>
                </dxi-item>
                <dxi-item>
                    <a [routerLink]="['/productionactivity/',selectedProductionActivityId]" target="_blank"
                        queryParamsHandling="preserve">Add/Edit Production Activity</a><br /><br />
                    <a [routerLink]="[]" (click)="refreshProductionActivities()">Refresh Production Activity</a>
                </dxi-item>
                <dxi-item dataField="specificProcessId">
                    <dxi-validation-rule type="required" message="Specific Process is required"></dxi-validation-rule>
                </dxi-item>
                <dxi-item>
                    <a [routerLink]="['/specificprocess/',selectedSpecificProcessId]" target="_blank"
                        queryParamsHandling="preserve">Add/Edit Specific Process</a><br /><br />
                    <a [routerLink]="[]" (click)="refreshSpecificProcess()">Refresh Specific Process</a>
                </dxi-item>
                <dxi-item dataField="feedstockId">
                    <dxi-validation-rule type="required" message="Feedstock is required"></dxi-validation-rule>
                </dxi-item>
                <dxi-item>
                    <a [routerLink]="['/feedstock/',selectedFeedstockId]" target="_blank"
                        queryParamsHandling="preserve">Add/Edit FeedStock</a><br /><br />
                    <a [routerLink]="[]" (click)="refreshFeedstock()">Refresh FeedStock</a>
                </dxi-item>
                <dxi-item dataField="businessCategoryId"></dxi-item>
                <dxi-item itemType="empty"></dxi-item>
                <dxi-item dataField="oxygen" caption="O2 (metric tonnes/metric tonne of product)" [width]="200">
                </dxi-item>
                <dxi-item dataField="isOxygenSupply" caption="O2 Supply?" [width]="150"></dxi-item>
                <dxi-item dataField="nitrogen" caption="N2 (metric tonnes/metric tonne of product)" [width]="200">
                </dxi-item>
                <dxi-item dataField="isNitrogenSupply" caption="N2 Supply?" [width]="150"></dxi-item>
                <dxi-item dataField="hydrogen" caption="H2 (kNm3 / metric tonne of product manufactured)" [width]="200">
                </dxi-item>
                <dxi-item dataField="isHydrogenSupply" caption="H2 Supply?" [width]="150"></dxi-item>
                <dxi-item dataField="syngas" caption="Syngas (kNm3 / metric tonne of product manufactured)"
                    [width]="200">
                </dxi-item>
                <dxi-item dataField="isSyngasSupply" caption="Syngas Supply?" [width]="150"></dxi-item>
                <dxi-item dataField="carbonMonoxide" caption="CO (kNm3 / metric tonne of product manufactured)"
                    [width]="200">
                </dxi-item>
                <dxi-item dataField="isCarbonMonoxideSupply" caption="Co Supply?" [width]="150"></dxi-item>
                <dxi-item dataField="steam" caption="Steam (metric tonnes/metric tonne of product)" [width]="200">
                </dxi-item>
                <dxi-item dataField="isSteamSupply" caption="Steam Supply?" [width]="150"></dxi-item>
                <dxi-item dataField="notes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 100 }">
                </dxi-item>
                <dxi-item dataField="isActive" caption="Active"></dxi-item>

            </dxo-form>
        </dxo-editing>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Add" type="default" (onClick)="addNew()"></dx-button>
                <dx-button text="Reset" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" type="default" text="Export to Excel" (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>
        <dxi-column type="buttons">
            <dxi-button name="edit"></dxi-button>
        </dxi-column>
        <dxi-column dataField="productionActivityId" [setCellValue]="setProductionActivityValue"
            caption="Production Activity" [width]="300">
            <dxo-lookup [dataSource]="getProdActivities" displayExpr="productionActivityName"
                valueExpr="productionActivityId">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="specificProcessId" [setCellValue]="setSpecificProcessValue" caption="Specific Process"
            [width]="300">
            <dxo-lookup [dataSource]="getSpecificProcessesDataSource" displayExpr="specificProcessName"
                valueExpr="specificProcessId">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="feedstockId" [setCellValue]="setFeedstockValue" caption="Feedstock" [width]="150">
            <dxo-lookup [dataSource]="getFeedstockDataSource" displayExpr="feedstockName" valueExpr="feedstockId">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="businessCategoryId"
            caption="Industry - Segment - Involves Gasif Using O2 Plus Solid/Liq Fuel" [width]="350">
            <dxo-lookup [dataSource]="businesscategories" displayExpr="name" valueExpr="id">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="oxygen" dataType="string" caption="O2 (metric tonnes/metric tonne of product)" [width]="200"></dxi-column>
        <dxi-column dataField="isOxygenSupply" caption="O2 Supply?" [width]="150"></dxi-column>
        <dxi-column dataField="nitrogen" dataType="string" caption="N2 (metric tonnes/metric tonne of product)" [width]="200">
        </dxi-column>
        <dxi-column dataField="isNitrogenSupply" caption="N2 Supply?" [width]="150"></dxi-column>
        <dxi-column dataField="hydrogen" dataType="string" caption="H2 (kNm3 / metric tonne of product manufactured)" [width]="200">
        </dxi-column>
        <dxi-column dataField="isHydrogenSupply" caption="H2 Supply?" [width]="150"></dxi-column>
        <dxi-column dataField="syngas" dataType="string" caption="Syngas (kNm3 / metric tonne of product manufactured)" [width]="200">
        </dxi-column>
        <dxi-column dataField="isSyngasSupply" caption="Syngas Supply?" [width]="150"></dxi-column>
        <dxi-column dataField="carbonMonoxide" dataType="string" caption="CO (kNm3 / metric tonne of product manufactured)" [width]="200">
        </dxi-column>
        <dxi-column dataField="isCarbonMonoxideSupply" caption="Co Supply?" [width]="150"></dxi-column>
        <dxi-column dataField="steam" dataType="string" caption="Steam (metric tonnes/metric tonne of product)" [width]="200">
        </dxi-column>
        <dxi-column dataField="isSteamSupply" caption="Steam Supply?" [width]="150"></dxi-column>
        <dxi-column dataField="notes" [width]="400">
        </dxi-column>
        <dxi-column dataField="modifiedBy" [width]="100"></dxi-column>
        <dxi-column dataField="modifiedDate" dataType="date" format="MM/dd/yyyy h:mm:ss a" [width]="100"></dxi-column>
        <dxi-column dataField="isActive" caption="Active" [visible]="false"></dxi-column>
    </dx-data-grid>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>